var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "block docx-view-block" }, [
    _c("div", [_vm._t("default", null, { tableId: _vm.tableId })], 2),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }